// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1Ri9K","name":"ConsentHeader_name__3PMKc","birthday":"ConsentHeader_birthday__2BjRc","skeleton":"ConsentHeader_skeleton__2c9w_"};